<template>
    <div>
        <div id="cartRight" class="slider-menu expand-lg expand-md">
            <span class="slider-btn" data-toggle="collapse" href="#cartMenu" aria-expanded="false" aria-controls="collapseCartMenu">
                <i class="csi-iconfont csi-menu normal"></i>
                <template v-if="canOrder">
                    {{labels[1015]}}<!-- Cart Options -->
                </template>
                <template v-else>
                    <span>
                        <span v-if="!isLoggedIn" v-html="labels[1017]"></span><!-- Account Options -->
                        <span v-else v-html="labels[1018]"></span><!-- Quote Instructions -->
                    </span>
                </template>
            </span>
            <div class="collapse" id="cartMenu">
                <div v-if="cart.info.attemptedLoad">
                    <p v-if="cart.info.loaded" class="alert alert-info">
                        <!-- dynamic message -->
                        <template v-if="cart.info.name.length">
                            <span v-html="cartInfoNameMsg"></span>
                        </template>
                        <template v-else>
                            {{labels[1019]}}<!-- A cart has been loaded. -->
                        </template>
                    </p>
                    <p v-else class="alert alert-info">
                        {{labels[1020]}}<!-- The cart you attempted to load does not exist or is no longer available. -->
                    </p>
                </div>
                <div v-if="!canOrder">
                    <p v-if="!isLoggedIn" v-html="labels[1021]"></p><!-- Campbell Scientific customers supported by this site are eligible for online accounts that provide online ordering and other functionality.
                    <a href="/login">Log in</a> or <a href="/login">register</a> to get started. -->
                    <p v-else v-html="labels[1022]"></p><!-- Please review the product quantities and verify that your product configurations are suitable for your application. Click the Request Quote button to continue the quote process. -->
                    <template v-if="cart.itemList.length > 6">
                        <div>
                            <br>
                            <a rel="nofollow" class="hidden-xs btn btn-primary btn-block" v-class="reqQuoteDisabled" href="/request-quote#form'">
                                {{labels[1014]}} <span>&rsaquo;</span><!-- Request Quote -->
                            </a>
                        </div>
                    </template>
                </div>
                <template v-if="canOrder">
                    <ul>
                        <CartSave />
                        <template v-if="cart.itemList.length">
                            <CartShare />
                            <CartClear />
                        </template>
                        <template v-else>
                            <li class="nolink">
                                <i class="csi-iconfont csi-share"></i>
                                {{labels[1025]}}<!-- label: Share Cart (title) -->
                            </li>
                            <li class="nolink">
                                <i class="csi-iconfont csi-cart"></i>
                                {{labels[1027]}}<!--label: start new cart -->
                            </li>
                        </template>
                    </ul>
                    <div id="cart-saved" :rel="cart.info.saved">
                        <div v-if="cart.info.name.length" class="margintop20">
                            <a href="" @click.prevent="toggleSaveCart" class="save-cart-vue"><!-- labels: Edit Cart Name/Notes, Cancel -->
                                <template v-if="cart.info.saved">
                                    {{labels[1038]}}<!-- Saved Cart: -->
                                </template>
                                <template v-else>
                                    {{labels[1039]}}<!-- Cart Name: -->
                                </template>
                            </a>
                            <strong>{{cart.info.name}}</strong>
                        </div>
                        <div v-if="cart.info.notes.length" id="c-notes">
                            <strong>{{labels[1040]}}<!-- Notes: --></strong><br />
                            <p>{{cart.info.notes}}</p>
                        </div>
                    </div>
                    <template v-if="hasCustomers && (custAll.length > 1 || (custAll.length && userLevel < 3))">
                        <hr>
                        <Org-Switcher :org-switcher-label-id="1172" />
                    </template>
                    <div v-if="isEcommerce && empCantOrder">
                        <!-- Shown to employees who have no customer/organization association or none selected -->
                        <p class="alert alert-danger margintop10">
                            {{labels[1011]}}<!-- Your account must be associated with an organization that is eligible to purchase online to proceed. -->
                        </p>
                    </div>
                    <br><br><br>
                    <template v-if="savedCarts.length">
                        <hr>
                        <ul>
                            <li>
                                <a href="/customer-center?mode=carts">
                                    {{labels[1016]}}<!-- View Saved Carts -->
                                </a>
                            </li>
                        </ul>
                    </template>
                </template>
            </div>
        </div>

        <div id="review-form" class="hidden popbox">
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import useCart from "../composables/useCart"
import useCMS from "../../shared/composables/useCMS"
import OrgSwitcher from '../components/OrgSwitcher.vue'
import CartShare from '../components/CartShare.vue'
import CartSave from '../components/CartSave.vue'
import CartClear from '../components/CartClear.vue'

export default {
    name: 'CartRight',
    components: {
        OrgSwitcher,
        CartShare,
        CartSave,
        CartClear
    },
    setup () {
        const { cart, canOrder, isLoggedIn, hasCustomers, custAll, userLevel, primaryCust, canSeePrices, empCantOrder, isEcommerce, savedCarts, toggleSaveCart } = useCart();
        const { labels, getDynamicMessage } = useCMS();

        const cartInfoNameMsg = ref('');
        if(cart.value.info.name.length){
            getDynamicMessage(12,{cartName: cart.value.info.name}).then((resp) => {
                if(resp.status == 200) {
                    cartInfoNameMsg.value = resp.data;
                }
            }).catch((error) => {
                console.log(error);
            });
        }

        return {
            cart,
            canOrder,
            isLoggedIn,
            hasCustomers,
            custAll,
            userLevel,
            primaryCust,
            canSeePrices,
            empCantOrder,
            isEcommerce,
            savedCarts,
            toggleSaveCart,
            labels,
            cartInfoNameMsg
        }
    }
}
</script>
